import React, { FC } from 'react';
import { I18nextProvider } from 'react-i18next';
import { useUserLanguage } from '@robinpowered/dashboard-apps-common';
import { i18n } from '../i18n';

type Args = {
  children: React.ReactNode;
};

export const LocalizationContext: FC<Args> = ({ children }: Args) => {
  useUserLanguage(i18n.language, i18n.changeLanguage);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
